export default __webpack_public_path__ + "vietnam-map-800-bea81442b2b648fdc2661ffa0bc6d4d8.webp";